module.exports = __webpack_public_path__ + "media/firstShowcase.e10ea292.mp4";